import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import { DatePicker, List,ActionSheet, ImageUploader, Selection, Card, Form, Input, Space, Toast, Button } from 'antd-mobile'
import './index.less'

const PageModel = props => {
	const [list, setList] = useState([]);
	const [values, setValues] = useState('');
	const [area, setArea] = useState(0);
	const [areaList, setAreaList] = useState([]);
	const [visible_area, setVisibleArea] = useState(false);

	const getAreaList = async () => {
		const result = await Request.get({
			url: '/area/list'
		});
		if (!result) return;

		const list = result.data.list || [];
		let array = [{ "text": '全部', "key": '' }];
		for (let index = 0; index < list.length; index++) {
			array.push({ "text": list[index].areaName, "key": list[index].id });
		}
		setAreaList(array);
	};

	const getList = async (data = {}) => {
		// if (Utils.getSearchByKey('cid') && !data.categoryId) {
		//   data.categoryId = Utils.getSearchByKey('cid')
		// }
		data.page = data.page || 0;
		const result = await Request.get({
			url: '/company/list',
			data
		});
		if (!result) return;
		console.log(result);
		// result.data.list.map(item => {
		// 	item.key = item.id;
		// 	return item;
		// });
		setList(result.data.list);
		// setListTotal(result.data.count);
		// setListQuery(data);
		// setListPageIndex(data.page);
	};
	useEffect(() => {
		//获取街道列表
		getAreaList()

		getList();//获取所有数据的列表
	}, [123]);

	return (
		<List>
			<List.Item onClick={() => setVisibleArea(true)} extra={values}>
				选择区域(默认全部)
			</List.Item>
			<ActionSheet
				visible={visible_area}
				actions={areaList}
				onClose={() => { setVisibleArea(false) }}
				onAction={action => {
					setVisibleArea(false)
					setValues(action.text)
					setArea(action.key)
					getList({subStreet: action.key});
				}}
			/>
			{
				list && list.length > 0 && list.map((item,index)=>{
					return (
						<List.Item key={index}>
							<div className='div_title'>
								<div className='div_title_left'>公司名称:</div>
								<div className='div_title_right'>{item.enterpriseName}</div>
							</div>
							<div className='div_title'>
								<div className='div_title_left'>店铺名称:</div>
								<div className='div_title_right'>{item.companyName}</div>
							</div>
							<div className='div_title'>
								<div className='div_title_left'>地址:</div>
								<div className='div_title_right'>{item.address}</div>
							</div>
							<div className='div_title'>
								<div className='div_title_left'>营业状态:</div>
								<div className='div_title_right'>{item.status ? '营业中' : '暂停营业'}</div>
							</div>
						</List.Item>
					)
				})
			}
			
		</List>
	);
};

export default PageModel;
